import BaseListStyle from "../../styles/BaseListStyle"; 

const GenerateFlightFixtureStyles = (theme) => { 
  const baseListStyle = BaseListStyle(theme);
  return {
    ...baseListStyle,
    /* Add custom styles here */
    scheduleLegs: {
      "& .MuiTableCell-root": {
        padding: 8,
      }
    }
  }
}

export default GenerateFlightFixtureStyles;